import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Unregister Service Worker to fix reload loop issue
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    // Unregister all service workers
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (let registration of registrations) {
        registration.unregister().then(() => {
          console.log('✅ Service Worker desregistrado');
        });
      }
    });
  });
}

// Note: PWA functionality temporarily disabled to fix critical refresh loop bug
// Will be re-enabled with proper update mechanism in future update
